export const translations = {
  es: {
    // Navigation
    'recursos-ia': 'Recursos de IA',
    'guia-esencial': 'Guía esencial para el presente y el futuro digital',
    // Hero Section
    'soluciones-innovadoras': 'Soluciones innovadoras actualizadas',
    'recursos-de': 'Recursos de',
    'ia': 'IA',
    'descripcion-hero': 'Descubre las mejores herramientas de inteligencia artificial para potenciar tu trabajo, creatividad y productividad',
    'herramientas-gratuitas': 'Herramientas gratuitas y ',
    'freemium': 'freemium',
    'organizadas-categorias': 'Organizadas por categorías',
    'actualizaciones-constantes': 'Actualizaciones constantes',
    // Search and Filter
    'buscar-herramientas': 'Buscar herramientas de IA...',
    'sugerencias-busqueda': 'Sugerencias de búsqueda:',
    'filtrar-categoria': 'Filtrar por categoría:',
    'todos': 'Todas',
    // Results
    'mostrando': 'Mostrando',
    'recurso': 'recurso',
    'recursos': 'recursos',
    'en': 'en',
    'no-encontraron': 'No se encontraron recursos',
    'intenta-otros': 'Intenta con otros términos de búsqueda o categorías',
    'mostrar-todos': 'Mostrar todos los recursos',
    // View Controls
    'vista-compacta': 'Vista compacta',
    'vista-expandida': 'Vista expandida',
    'expandir-todo': 'Expandir todo',
    'colapsar-todo': 'Colapsar todo',
    // Footer
    'una-aplicacion-de': 'Una aplicación de',
    'copyright-text': '© 2026, Alfredo Menéndez',
    'copyright-title': 'Recursos de IA',
    'sigueme-tiktok': 'Sígueme en TikTok',
    'descripcion-footer': 'Descubre las mejores herramientas de inteligencia artificial para potenciar tu trabajo, creatividad y productividad',
    // Categories
    'investigacion': 'Investigación',
    'texto-redaccion': 'Texto y redacción',
    'educacion': 'Educación',
    'chatbots': 'Chatbots',
    'video': 'Video',
    'mapas-mentales': 'Mapas mentales',
    'imagenes': 'Imágenes',
    'diseno': 'Diseño',
    'generador-asistentes': 'Generador de asistentes virtuales',
    'detector-contenidos': 'Detector de contenidos de IA',
    'musica': 'Música',
    'motores-busqueda': 'Motores de búsqueda',
    'audio': 'Audio',
    'redes-sociales': 'Redes sociales'
  },
  en: {
    // Navigation
    'recursos-ia': 'AI Resources',
    'guia-esencial': 'Essential guide for the present and digital future',
    // Hero Section
    'soluciones-innovadoras': 'Updated innovative solutions',
    'recursos-de': 'AI',
    'ia': 'Resources',
    'descripcion-hero': 'Discover the best artificial intelligence tools to boost your work, creativity and productivity',
    'herramientas-gratuitas': 'Free and ',
    'freemium': 'freemium',
    'organizadas-categorias': 'Organized by categories',
    'actualizaciones-constantes': 'Constant updates',
    // Search and Filter
    'buscar-herramientas': 'Search AI tools...',
    'sugerencias-busqueda': 'Search suggestions:',
    'filtrar-categoria': 'Filter by category:',
    'todos': 'All',
    // Results
    'mostrando': 'Showing',
    'recurso': 'resource',
    'recursos': 'resources',
    'en': 'in',
    'no-encontraron': 'No resources found',
    'intenta-otros': 'Try other search terms or categories',
    'mostrar-todos': 'Show all resources',
    // View Controls
    'vista-compacta': 'Compact view',
    'vista-expandida': 'Expanded view',
    'expandir-todo': 'Expand all',
    'colapsar-todo': 'Collapse all',
    // Footer
    'una-aplicacion-de': 'An application by',
    'copyright-text': '© 2026, Alfredo Menéndez',
    'copyright-title': 'AI Resources',
    'sigueme-tiktok': 'Follow me on TikTok',
    'descripcion-footer': 'Discover the best artificial intelligence tools to boost your work, creativity and productivity',
    // Categories
    'investigacion': 'Research',
    'texto-redaccion': 'Text and writing',
    'educacion': 'Education',
    'chatbots': 'Chatbots',
    'video': 'Video',
    'mapas-mentales': 'Mind maps',
    'imagenes': 'Images',
    'diseno': 'Design',
    'generador-asistentes': 'Virtual assistant generator',
    'detector-contenidos': 'AI content detector',
    'musica': 'Music',
    'motores-busqueda': 'Search engines',
    'audio': 'Audio',
    'redes-sociales': 'Social media'
  },
  pt: {
    // Navigation
    'recursos-ia': 'Recursos de IA',
    'guia-esencial': 'Guia essencial para o presente e futuro digital',
    // Hero Section
    'soluciones-innovadoras': 'Soluções inovadoras atualizadas',
    'recursos-de': 'Recursos de',
    'ia': 'IA',
    'descripcion-hero': 'Descubra as melhores ferramentas de inteligência artificial para potencializar seu trabalho, criatividade e produtividade',
    'herramientas-gratuitas': 'Ferramentas gratuitas e ',
    'freemium': 'freemium',
    'organizadas-categorias': 'Organizadas por categorias',
    'actualizaciones-constantes': 'Atualizações constantes',
    // Search and Filter
    'buscar-herramientas': 'Buscar ferramentas de IA...',
    'sugerencias-busqueda': 'Sugestões de busca:',
    'filtrar-categoria': 'Filtrar por categoria:',
    'todos': 'Todos',
    // Results
    'mostrando': 'Mostrando',
    'recurso': 'recurso',
    'recursos': 'recursos',
    'en': 'em',
    'no-encontraron': 'Nenhum recurso encontrado',
    'intenta-otros': 'Tente outros termos de busca ou categorias',
    'mostrar-todos': 'Mostrar todos os recursos',
    // View Controls
    'vista-compacta': 'Vista compacta',
    'vista-expandida': 'Vista expandida',
    'expandir-todo': 'Expandir tudo',
    'colapsar-todo': 'Recolher tudo',
    // Footer
    'una-aplicacion-de': 'Uma aplicação de',
    'copyright-text': '© 2026, Alfredo Menéndez',
    'copyright-title': 'Recursos de IA',
    'sigueme-tiktok': 'Siga-me no TikTok',
    'descripcion-footer': 'Descubra as melhores ferramentas de inteligência artificial para potencializar seu trabalho, criatividade e produtividade',
    // Categories
    'investigacion': 'Pesquisa',
    'texto-redaccion': 'Texto e redação',
    'educacion': 'Educação',
    'chatbots': 'Chatbots',
    'video': 'Vídeo',
    'mapas-mentales': 'Mapas mentais',
    'imagenes': 'Imagens',
    'diseno': 'Design',
    'generador-asistentes': 'Gerador de assistentes virtuais',
    'detector-contenidos': 'Detector de conteúdo de IA',
    'musica': 'Música',
    'motores-busqueda': 'Motores de busca',
    'audio': 'Áudio',
    'redes-sociales': 'Redes sociais'
  },
  fr: {
    // Navigation
    'recursos-ia': 'Ressources IA',
    'guia-esencial': "Guide essentiel pour le présent et l'avenir numérique",
    // Hero Section
    'soluciones-innovadoras': 'Solutions innovantes mises à jour',
    'recursos-de': 'Ressources',
    'ia': 'IA',
    'descripcion-hero': "Découvrez les meilleurs outils d'intelligence artificielle pour booster votre travail, créativité et productivité",
    'herramientas-gratuitas': 'Outils gratuits et ',
    'freemium': 'freemium',
    'organizadas-categorias': 'Organisées par catégories',
    'actualizaciones-constantes': 'Mises à jour constantes',
    // Search and Filter
    'buscar-herramientas': 'Rechercher des outils IA...',
    'sugerencias-busqueda': 'Suggestions de recherche:',
    'filtrar-categoria': 'Filtrer par catégorie:',
    'todos': 'Tous',
    // Results
    'mostrando': 'Affichage de',
    'recurso': 'ressource',
    'recursos': 'ressources',
    'en': 'dans',
    'no-encontraron': 'Aucune ressource trouvée',
    'intenta-otros': 'Essayez d\'autres termes de recherche ou catégories',
    'mostrar-todos': 'Afficher toutes les ressources',
    // View Controls
    'vista-compacta': 'Vue compacte',
    'vista-expandida': 'Vue étendue',
    'expandir-todo': 'Tout étendre',
    'colapsar-todo': 'Tout réduire',
    // Footer
    'una-aplicacion-de': 'Une application de',
    'copyright-text': '© 2026, Alfredo Menéndez',
    'copyright-title': 'Ressources IA',
    'sigueme-tiktok': 'Suivez-moi sur TikTok',
    'descripcion-footer': "Découvrez les meilleurs outils d'intelligence artificielle pour booster votre travail, créativité et productivité",
    // Categories
    'investigacion': 'Recherche',
    'texto-redaccion': 'Texte et rédaction',
    'educacion': 'Éducation',
    'chatbots': 'Chatbots',
    'video': 'Vidéo',
    'mapas-mentales': 'Cartes mentales',
    'imagenes': 'Images',
    'diseno': 'Design',
    'generador-asistentes': 'Générateur d\'assistants virtuels',
    'detector-contenidos': 'Détecteur de contenu IA',
    'musica': 'Musique',
    'motores-busqueda': 'Moteurs de recherche',
    'audio': 'Audio',
    'redes-sociales': 'Réseaux sociaux'
  },
  de: {
    // Navigation
    'recursos-ia': 'KI-Ressourcen',
    'guia-esencial': 'Wesentlicher Leitfaden für Gegenwart und digitale Zukunft',
    // Hero Section
    'soluciones-innovadoras': 'Aktualisierte innovative Lösungen',
    'recursos-de': 'KI',
    'ia': 'Ressourcen',
    'descripcion-hero': 'Entdecken Sie die besten Tools der künstlichen Intelligenz zur Steigerung Ihrer Arbeit, Kreativität und Produktivität',
    'herramientas-gratuitas': 'Kostenlose und ',
    'freemium': 'Freemium',
    'organizadas-categorias': 'Nach Kategorien organisiert',
    'actualizaciones-constantes': 'Ständige Updates',
    // Search and Filter
    'buscar-herramientas': 'KI-Tools suchen...',
    'sugerencias-busqueda': 'Suchvorschläge:',
    'filtrar-categoria': 'Nach Kategorie filtern:',
    'todos': 'Alle',
    // Results
    'mostrando': 'Anzeige von',
    'recurso': 'Ressource',
    'recursos': 'Ressourcen',
    'en': 'in',
    'no-encontraron': 'Keine Ressourcen gefunden',
    'intenta-otros': 'Versuchen Sie andere Suchbegriffe oder Kategorien',
    'mostrar-todos': 'Alle Ressourcen anzeigen',
    // View Controls
    'vista-compacta': 'Kompakte Ansicht',
    'vista-expandida': 'Erweiterte Ansicht',
    'expandir-todo': 'Alle erweitern',
    'colapsar-todo': 'Alle reduzieren',
    // Footer
    'una-aplicacion-de': 'Eine Anwendung von',
    'copyright-text': '© 2026, Alfredo Menéndez',
    'copyright-title': 'KI-Ressourcen',
    'sigueme-tiktok': 'Folgen Sie mir auf TikTok',
    'descripcion-footer': 'Entdecken Sie die besten Tools der künstlichen Intelligenz zur Steigerung Ihrer Arbeit, Kreativität und Produktivität',
    // Categories
    'investigacion': 'Forschung',
    'texto-redaccion': 'Text und Schreiben',
    'educacion': 'Bildung',
    'chatbots': 'Chatbots',
    'video': 'Video',
    'mapas-mentales': 'Mind Maps',
    'imagenes': 'Bilder',
    'diseno': 'Design',
    'generador-asistentes': 'Generator für virtuelle Assistenten',
    'detector-contenidos': 'KI-Inhaltsdetektor',
    'musica': 'Musik',
    'motores-busqueda': 'Suchmaschinen',
    'audio': 'Audio',
    'redes-sociales': 'Soziale Medien'
  },
  it: {
    // Navigation
    'recursos-ia': 'Risorse IA',
    'guia-esencial': 'Guida essenziale per il presente e il futuro digitale',
    // Hero Section
    'soluciones-innovadoras': 'Soluzioni innovative aggiornate',
    'recursos-de': 'Risorse',
    'ia': 'IA',
    'descripcion-hero': 'Scopri i migliori strumenti di intelligenza artificiale per potenziare il tuo lavoro, creatività e produttività',
    'herramientas-gratuitas': 'Strumenti gratuiti e ',
    'freemium': 'freemium',
    'organizadas-categorias': 'Organizzate per categorie',
    'actualizaciones-constantes': 'Aggiornamenti costanti',
    // Search and Filter
    'buscar-herramientas': 'Cerca strumenti IA...',
    'sugerencias-busqueda': 'Suggerimenti di ricerca:',
    'filtrar-categoria': 'Filtra per categoria:',
    'todos': 'Tutti',
    // Results
    'mostrando': 'Mostrando',
    'recurso': 'risorsa',
    'recursos': 'risorse',
    'en': 'in',
    'no-encontraron': 'Nessuna risorsa trovata',
    'intenta-otros': 'Prova altri termini di ricerca o categorie',
    'mostrar-todos': 'Mostra tutte le risorse',
    // View Controls
    'vista-compacta': 'Vista compatta',
    'vista-expandida': 'Vista espansa',
    'expandir-todo': 'Espandi tutto',
    'colapsar-todo': 'Riduci tutto',
    // Footer
    'una-aplicacion-de': 'Un\'applicazione di',
    'copyright-text': '© 2026, Alfredo Menéndez',
    'copyright-title': 'Risorse IA',
    'sigueme-tiktok': 'Seguimi su TikTok',
    'descripcion-footer': 'Scopri i migliori strumenti di intelligenza artificiale per potenziare il tuo lavoro, creatività e produttività',
    // Categories
    'investigacion': 'Ricerca',
    'texto-redaccion': 'Testo e scrittura',
    'educacion': 'Educazione',
    'chatbots': 'Chatbot',
    'video': 'Video',
    'mapas-mentales': 'Mappe mentali',
    'imagenes': 'Immagini',
    'diseno': 'Design',
    'generador-asistentes': 'Generatore di assistenti virtuali',
    'detector-contenidos': 'Rilevatore di contenuti IA',
    'musica': 'Musica',
    'motores-busqueda': 'Motori di ricerca',
    'audio': 'Audio',
    'redes-sociales': 'Social media'
  },
  zh: {
    // Navigation
    'recursos-ia': 'AI资源',
    'guia-esencial': '现在和数字未来的基本指南',
    // Hero Section
    'soluciones-innovadoras': '更新的创新解决方案',
    'recursos-de': 'AI',
    'ia': '资源',
    'descripcion-hero': '发现最好的人工智能工具来提升您的工作、创造力和生产力',
    'herramientas-gratuitas': '免费和',
    'freemium': '免费增值',
    'organizadas-categorias': '按类别组织',
    'actualizaciones-constantes': '持续更新',
    // Search and Filter
    'buscar-herramientas': '搜索AI工具...',
    'sugerencias-busqueda': '搜索建议：',
    'filtrar-categoria': '按类别筛选：',
    'todos': '全部',
    // Results
    'mostrando': '显示',
    'recurso': '资源',
    'recursos': '资源',
    'en': '在',
    'no-encontraron': '未找到资源',
    'intenta-otros': '尝试其他搜索词 or 类别',
    'mostrar-todos': '显示所有资源',
    // View Controls
    'vista-compacta': '紧凑视图',
    'vista-expandida': '展开视图',
    'expandir-todo': '全部展开',
    'colapsar-todo': '全部折叠',
    // Footer
    'una-aplicacion-de': '出品',
    'copyright-text': '© 2026, 阿尔弗雷多·梅嫩德斯',
    'copyright-title': 'AI资源',
    'sigueme-tiktok': '在TikTok上关注我',
    'descripcion-footer': '发现最好的人工智能工具来提升您的工作、创造力和生产力',
    // Categories
    'investigacion': '研究',
    'texto-redaccion': '文本和写作',
    'educacion': '教育',
    'chatbots': '聊天机器人',
    'video': '视频',
    'mapas-mentales': '思维导图',
    'imagenes': '图像',
    'diseno': '设计',
    'generador-asistentes': '虚拟助手生成器',
    'detector-contenidos': 'AI内容检测器',
    'musica': '音乐',
    'motores-busqueda': '搜索引擎',
    'audio': '音频',
    'redes-sociales': '社交媒体'
  },
  ja: {
    // Navigation
    'recursos-ia': 'AIリソース',
    'guia-esencial': '現在とデジタル未来のための必須ガイド',
    // Hero Section
    'soluciones-innovadoras': '更新された革新的ソリューション',
    'recursos-de': 'AI',
    'ia': 'リソース',
    'descripcion-hero': 'あなたの仕事、創造性、生産性を向上させる最高の人工知能ツールを発見してください',
    'herramientas-gratuitas': '無料と',
    'freemium': 'フリーミアム',
    'organizadas-categorias': 'カテゴリ別に整理',
    'actualizaciones-constantes': '継続的な更新',
    // Search and Filter
    'buscar-herramientas': 'AIツールを検索...',
    'sugerencias-busqueda': '検索候補：',
    'filtrar-categoria': 'カテゴリでフィルタ：',
    'todos': 'すべて',
    // Results
    'mostrando': '表示中',
    'recurso': 'リソース',
    'recursos': 'リソース',
    'en': 'の',
    'no-encontraron': 'リソースが見つかりません',
    'intenta-otros': '他の検索用語やカテゴリを試してください',
    'mostrar-todos': 'すべてのリソースを表示',
    // View Controls
    'vista-compacta': 'コンパクト表示',
    'vista-expandida': '拡張表示',
    'expandir-todo': 'すべて展開',
    'colapsar-todo': 'すべて折りたたみ',
    // Footer
    'una-aplicacion-de': 'によるアプリ',
    'copyright-text': '© 2026, アルフレド・メネンデス',
    'copyright-title': 'AIリソース',
    'sigueme-tiktok': 'TikTokでフォローしてください',
    'descripcion-footer': 'あなたの仕事、創造性、生産性を向上させる最高の人工知能ツールを発見してください',
    // Categories
    'investigacion': '研究',
    'texto-redaccion': 'テキストと執筆',
    'educacion': '教育',
    'chatbots': 'チャットボット',
    'video': 'ビデオ',
    'mapas-mentales': 'マインドマップ',
    'imagenes': '画像',
    'diseno': 'デザイン',
    'generador-asistentes': '仮想アシスタント生成器',
    'detector-contenidos': 'AIコンテンツ検出器',
    'musica': '音楽',
    'motores-busqueda': '検索エンジン',
    'audio': 'オーディオ',
    'redes-sociales': 'ソーシャルメディア'
  },
  ko: {
    // Navigation
    'recursos-ia': 'AI 리소스',
    'guia-esencial': '현재와 디지털 미래를 위한 필수 가이드',
    // Hero Section
    'soluciones-innovadoras': '업데이트된 혁신적인 솔루션',
    'recursos-de': 'AI',
    'ia': '리소스',
    'descripcion-hero': '당신의 업무, 창의성, 생산성을 향상시키는 최고의 인공지능 도구를 발견하세요',
    'herramientas-gratuitas': '무료 및 ',
    'freemium': '프리미엄',
    'organizadas-categorias': '카테고리별 정리',
    'actualizaciones-constantes': '지속적인 업데이트',
    // Search and Filter
    'buscar-herramientas': 'AI 도구 검색...',
    'sugerencias-busqueda': '검색 제안:',
    'filtrar-categoria': '카테고리로 필터링:',
    'todos': '모든',
    // Results
    'mostrando': '표시 중',
    'recurso': '리소스',
    'recursos': '리소스',
    'en': '의',
    'no-encontraron': '리소스를 찾을 수 없음',
    'intenta-otros': '다른 검색어나 카테고리를 시도해보세요',
    'mostrar-todos': '모든 리소스 표시',
    // View Controls
    'vista-compacta': '간단한 보기',
    'vista-expandida': '확장된 보기',
    'expandir-todo': '모두 확장',
    'colapsar-todo': '모두 축소',
    // Footer
    'una-aplicacion-de': '의 앱',
    'copyright-text': '© 2026, 알프레도 메넨데스',
    'copyright-title': 'AI 리소스',
    'sigueme-tiktok': 'TikTok에서 팔로우하세요',
    'descripcion-footer': '당신의 업무, 창의성, 생산성을 향상시키는 최고의 인공지능 도구를 발견하세요',
    // Categories
    'investigacion': '연구',
    'texto-redaccion': '텍스트 및 작성',
    'educacion': '교육',
    'chatbots': '챗봇',
    'video': '비디오',
    'mapas-mentales': '마인드맵',
    'imagenes': '이미지',
    'diseno': '디자인',
    'generador-asistentes': '가상 어시스턴트 생성기',
    'detector-contenidos': 'AI 콘텐츠 감지기',
    'musica': '음악',
    'motores-busqueda': '검색 엔진',
    'audio': '오디오',
    'redes-sociales': '소셜 미디어'
  },
  pl: {
    // Navigation
    'recursos-ia': 'Zasoby AI',
    'guia-esencial': 'Niezbędny przewodnik po teraźniejszości i cyfrowej przyszłości',
    // Hero Section
    'soluciones-innovadoras': 'Zaktualizowane innowacyjne rozwiązania',
    'recursos-de': 'Zasoby',
    'ia': 'AI',
    'descripcion-hero': 'Odkryj najlepsze narzędzia sztucznej inteligencji, aby wzmocnić swoją pracę, kreatywność i produktywność',
    'herramientas-gratuitas': 'Bezpłatne e ',
    'freemium': 'freemium',
    'organizadas-categorias': 'Uporządkowane według kategorii',
    'actualizaciones-constantes': 'Stałe aktualizacje',
    // Search and Filter
    'buscar-herramientas': 'Szukaj narzędzi AI...',
    'sugerencias-busqueda': 'Sugestie wyszukiwania:',
    'filtrar-categoria': 'Filtruj według kategorii:',
    'todos': 'Wszystkie',
    // Results
    'mostrando': 'Pokazywanie',
    'recurso': 'zasób',
    'recursos': 'zasoby',
    'en': 'w',
    'no-encontraron': 'Nie znaleziono zasobów',
    'intenta-otros': 'Spróbuj innych terminów wyszukiwania lub kategorii',
    'mostrar-todos': 'Pokaż wszystkie zasoby',
    // View Controls
    'vista-compacta': 'Widok kompaktowy',
    'vista-expandida': 'Widok rozszerzony',
    'expandir-todo': 'Rozwiń wszystko',
    'colapsar-todo': 'Zwiń wszystko',
    // Footer
    'una-aplicacion-de': 'Aplikacja od',
    'copyright-text': '© 2026, Alfredo Menéndez',
    'copyright-title': 'Zasoby AI',
    'sigueme-tiktok': 'Śledź mnie na TikTok',
    'descripcion-footer': 'Odkryj najlepsze narzędzia sztucznej inteligencji, aby wzmocnić swoją pracę, kreatywność i produktywność',
    // Categories
    'investigacion': 'Badania',
    'texto-redaccion': 'Tekst i pisanie',
    'educacion': 'Edukacja',
    'chatbots': 'Chatboty',
    'video': 'Wideo',
    'mapas-mentales': 'Mapy myśli',
    'imagenes': 'Obrazy',
    'diseno': 'Design',
    'generador-asistentes': 'Generator wirtualnych asystentów',
    'detector-contenidos': 'Detektor treści AI',
    'musica': 'Muzyka',
    'motores-busqueda': 'Wyszukiwarki',
    'audio': 'Audio',
    'redes-sociales': 'Media społecznościowe'
  },
  ro: {
    // Navigation
    'recursos-ia': 'Resurse AI',
    'guia-esencial': 'Ghid esențial pentru prezent și viitorul digital',
    // Hero Section
    'soluciones-innovadoras': 'Soluții inovatoare actualizate',
    'recursos-de': 'Resurse',
    'ia': 'AI',
    'descripcion-hero': 'Descoperă cele mai bune instrumente de inteligență artificială pentru a-ți îmbunătăți munca, creativitatea și productivitatea',
    'herramientas-gratuitas': 'Instrumente gratuite și ',
    'freemium': 'freemium',
    'organizadas-categorias': 'Organizate pe categorii',
    'actualizaciones-constantes': 'Actualizări constante',
    // Search and Filter
    'buscar-herramientas': 'Caută instrumente AI...',
    'sugerencias-busqueda': 'Sugestii de căutare:',
    'filtrar-categoria': 'Filtrează după categorie:',
    'todos': 'Toate',
    // Results
    'mostrando': 'Afișare',
    'recurso': 'resursă',
    'recursos': 'resurse',
    'en': 'în',
    'no-encontraron': 'Nu s-au găsit resurse',
    'intenta-otros': 'Încearcă alți termeni de căutare sau categorii',
    'mostrar-todos': 'Afișează toate resursele',
    // View Controls
    'vista-compacta': 'Vizualizare compactă',
    'vista-expandida': 'Vizualizare extinsă',
    'expandir-todo': 'Extinde toate',
    'colapsar-todo': 'Restrânge toate',
    // Footer
    'una-aplicacion-de': 'O aplicație de',
    'copyright-text': '© 2026, Alfredo Menéndez',
    'copyright-title': 'Resurse AI',
    'sigueme-tiktok': 'Urmărește-mă pe TikTok',
    'descripcion-footer': 'Descoperă cele mai bune instrumente de inteligență artificială pentru a-ți îmbunătăți munca, creativitatea și productivitatea',
    // Categories
    'investigacion': 'Cercetare',
    'texto-redaccion': 'Text și redactare',
    'educacion': 'Educație',
    'chatboți': 'Chatboți',
    'video': 'Video',
    'mapas-mentales': 'Hărți mentale',
    'imagenes': 'Imagini',
    'diseno': 'Design',
    'generador-asistentes': 'Generator de asistenți virtuali',
    'detector-contenidos': 'Detector de conținut AI',
    'musica': 'Muzică',
    'motores-busqueda': 'Motoare de căutare',
    'audio': 'Audio',
    'redes-sociales': 'Rețele sociale'
  }
};

export const flags = {
  es: '🇨🇴', // Colombia flag
  en: '🇺🇸',
  pt: '🇧🇷',
  fr: '🇫🇷',
  de: '🇩🇪',
  it: '🇮🇹',
  zh: '🇨🇳',
  ja: '🇯🇵',
  ko: '🇰🇷',
  pl: '🇵🇱',
  ro: '🇷🇴'
};